module.exports = __webpack_public_path__ + "assets/img/3e11-my.svg";